import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold mb-3">
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              关于每日大赛你关心的都在这里
            </h2>
          </div>

          <div className="space-y-3">
            {faqData.map((faq) => (
              <details
                key={faq.id}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:rotate-45 transition-transform duration-300">
                    <i className="ri-add-line"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}